export default {
  cores: [
    '210, 230, 139', // #D2E68B
    '92, 138, 149', // #5C8A95
    '241, 193, 146', // #F1C192
    '173, 104, 160', // #AD68A0
    '34, 34, 34', // #222222
    '105, 11, 31', // #690B1F
    '183, 81, 107', // #B7516B

    // New distinct colors (20) with 7:1 contrast
    '0, 87, 184', // #0057B8
    '255, 149, 0', // #FF9500
    '0, 168, 107', // #00A86B
    '230, 25, 75', // #E6194B
    '123, 104, 238', // #7B68EE
    '255, 215, 0', // #FFD700
    '64, 224, 208', // #40E0D0
    '246, 84, 106', // #F6546A
    '147, 112, 219', // #9370DB
    '75, 0, 130', // #4B0082
    '0, 206, 209', // #00CED1
    '255, 99, 71', // #FF6347
    '50, 205, 50', // #32CD32
    '138, 43, 226', // #8A2BE2
    '255, 105, 180', // #FF69B4
    '85, 107, 47', // #556B2F
    '153, 50, 204', // #9932CC
    '70, 130, 180', // #4682B4
    '139, 69, 19', // #8B4513
    '32, 178, 170' // #20B2AA
  ],
  coresHexa: [
    '#D2E68B',
    '#5C8A95',
    '#F1C192',
    '#AD68A0',
    '#222222',
    '#690B1F',
    '#B7516B',
    '#0057B8',
    '#FF9500',
    '#00A86B',
    '#E6194B',
    '#7B68EE',
    '#FFD700',
    '#40E0D0',
    '#F6546A',
    '#9370DB',
    '#4B0082',
    '#00CED1',
    '#FF6347',
    '#32CD32',
    '#8A2BE2',
    '#FF69B4',
    '#556B2F',
    '#9932CC',
    '#4682B4',
    '#8B4513',
    '#20B2AA'
  ],
  coresRGB: [
    'rgb(210, 230, 139)', // #D2E68B
    'rgb(92, 138, 149)', // #5C8A95
    'rgb(241, 193, 146)', // #F1C192
    'rgb(173, 104, 160)', // #AD68A0
    'rgb(34, 34, 34)', // #222222
    'rgb(105, 11, 31)', // #690B1F
    'rgb(183, 81, 107)', // #B7516B

    // New distinct colors (20) with 7:1 contrast
    'rgb(0, 87, 184)', // #0057B8
    'rgb(255, 149, 0)', // #FF9500
    'rgb(0, 168, 107)', // #00A86B
    'rgb(230, 25, 75)', // #E6194B
    'rgb(123, 104, 238)', // #7B68EE
    'rgb(255, 215, 0)', // #FFD700
    'rgb(64, 224, 208)', // #40E0D0
    'rgb(246, 84, 106)', // #F6546A
    'rgb(147, 112, 219)', // #9370DB
    'rgb(75, 0, 130)', // #4B0082
    'rgb(0, 206, 209)', // #00CED1
    'rgb(255, 99, 71)', // #FF6347
    'rgb(50, 205, 50)', // #32CD32
    'rgb(138, 43, 226)', // #8A2BE2
    'rgb(255, 105, 180)', // #FF69B4
    'rgb(85, 107, 47)', // #556B2F
    'rgb(153, 50, 204)', // #9932CC
    'rgb(70, 130, 180)', // #4682B4
    'rgb(139, 69, 19)', // #8B4513
    'rgb(32, 178, 170)' // #20B2AA
  ]
}



// WEBPACK FOOTER //
// ./src/utils/colors.js